import { useState } from "#imports";
export default function useSitisPopupGallery() {
  const isOpen = useState("isOpenPopupGallery", () => false);
  const imagesIds = useState("imagesIdsPopupGallery", () => []);
  const title = useState("titlePopupGallery", () => "");
  const description = useState("descriptionPopupGallery", () => "");
  const indexActiveSlide = useState("indexActiveSlidePopupGallery", () => 0);
  const setStateValue = (values) => {
    if (values.isOpen !== void 0) {
      isOpen.value = values.isOpen;
    }
    if (values.imagesIds !== void 0 && Array.isArray(values.imagesIds) && values.imagesIds.length > 0) {
      imagesIds.value = values.imagesIds.filter((id) => id !== void 0);
    }
    if (values.title !== void 0) {
      title.value = values.title;
    }
    if (values.description !== void 0) {
      description.value = values.description;
    }
    if (values.indexActiveSlide !== void 0) {
      indexActiveSlide.value = values.indexActiveSlide;
    }
  };
  return {
    isOpen,
    imagesIds,
    title,
    description,
    setStateValue,
    indexActiveSlide
  };
}
